/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/TimelineEvent/CustomResource/Content/Name"
  
}) {
let customResourceNameValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'name',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="custom_resource.name"
 text={customResourceNameValueData}
 weight="medium"
 size="large"
 marginTop={0}
/>
{children}
</React.Fragment>)
}